import { render, staticRenderFns } from "./TermsOfUseComponent.vue?vue&type=template&id=4d22843f&scoped=true&"
import script from "./TermsOfUseComponent.vue?vue&type=script&lang=js&"
export * from "./TermsOfUseComponent.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfUseComponent.vue?vue&type=style&index=0&id=4d22843f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d22843f",
  null
  
)

export default component.exports